module.exports = __webpack_public_path__ + "static/media/bajsz.9199c0c0.svg";